export const REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_SIDE_WORKERS =
  'sideWorkers'

export const REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_IS_INVITATION =
  'isSideWorkersInvitation'

export const REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_COMMENT =
  'sideWorkersComment'

export const REQUEST_PROFILE_WIDGET_SIDE_WORKERS_FIELD_NAME_HAS_INVALID_INPUT =
  'sideWorkersHasInvalidInput'
